module.exports = "/_next/static/images/photoOctavianMantaluta-47ecf4504146b129a51bd55fd39890cf.webp";